import {Local} from '../Local';
import {DateTimeCurrentFactory} from 'md-library-test-first-version';
import {Injectable} from '@angular/core';

@Injectable()
export class Factory {

    private dateTimeCurrentFactory: DateTimeCurrentFactory = null;

    // ########################################

    constructor(dateTimeCurrentFactory: DateTimeCurrentFactory) {
        this.dateTimeCurrentFactory = dateTimeCurrentFactory;
    }

    // ########################################

    public create(): Local {
        const localStorage: Storage = window.localStorage;

        return new Local(
            localStorage,
            this.dateTimeCurrentFactory
        );
    }

    // ########################################
}
